<template>
  <div class="synopsis">
    <aboutNav></aboutNav>
    <!-- 1100px -->
    <div style="width: 100%; margin: 0 auto">
      <img
        style="width: 100%; display: block"
        src="https://img.duoduiduo.com/gg/27/17/8888b29dd56045608fb11335efd28a95.jpg"
        alt=""
      />
    </div>
 
    <!--首创四位一体-->
    <div ref="pronbit" class="swyt container-fluid col-md-12">
      <!-- <h3 class="title container" style="color: #ee7b1d;">我们的企业文化</h3> -->
      <!-- <div class="badada">
          <div @mouseover="type1=2" @mouseout="type1=1">
            <img  :src="type1 == 1?require('../../assets/images/about/定位未点击.png'):require('../../assets/images/about/定位点击.png')" alt="">
            <span>定位</span>
            <p>健康管理<br>数智服务商</p>
          </div>
		  <div  @mouseover="type4=2" @mouseout="type4=1">
            <img  :src="type4 == 1?require('../../assets/images/about/使命未点击.png'):require('../../assets/images/about/使命点击.png')" alt="">
            <span>使命</span>
            <p>防大病·管慢病·促健康</p>
          </div>
          <div @mouseover="type2=2" @mouseout="type2=1">
            <img :src="type2 == 1?require('../../assets/images/about/愿景未点击.png'):require('../../assets/images/about/愿景点击.png')" alt="">
            <span>愿景</span>
            <p>健康管理<br>数智服务领跑者</p>
          </div>
          <div  @mouseover="type3=2" @mouseout="type3=1">
            <img   :src="type3 == 1?require('../../assets/images/about/价值观未点击.png'):require('../../assets/images/about/价值观点击.png')" alt="">
            <span>价值观</span>
            <p>开放·互助·共同体</p>
          </div>
		  <div @mouseover="type5=2" @mouseout="type5=1">
            <img  :src="type5 == 1?require('../../assets/images/about/目标未点击.png'):require('../../assets/images/about/目标点击.png')" alt="">
            <span>目标</span>
            <p>成为健康科技独角兽<br>实现千亿市值</p>
          </div>

      </div> -->

      <div class="asdadadada">
        <h3 class="title header_title">董事会</h3>
        <div class="line" style="margin-bottom: 40px"></div>
        <div class="swiper-box" style="width: 1100px; margin: 0px auto">
          <!-- swiper1 -->
          <swiper
            :options="swiperOptionTop"
            class="gallery-top"
            ref="swiperTop"
          >
            <swiper-slide v-for="(item, index) in swiperData" :key="index">
              <img :src="item.imgUrl" />
            </swiper-slide>
            <div
              class="swiper-button-next swiper-button-white"
              slot="button-next"
            ></div>
            <!-- <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div> -->
          </swiper>
        </div>

        <h3 class="title header_title">总裁办</h3>
        <div class="line" style="margin-bottom: 40px"></div>
        <div class="swiper-box" style="width: 1100px; margin: 0px auto">
          <!-- swiper1 -->
          <swiper
            :options="swiperOptionTop"
            class="gallery-top"
            ref="swiperTop"
          >
            <swiper-slide v-for="(item, index) in swiperData1" :key="index">
              <img :src="item.imgUrl" />
            </swiper-slide>
            <div
              class="swiper-button-next swiper-button-white"
              slot="button-next"
            ></div>
            <!-- <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div> -->
          </swiper>
        </div>

        <!-- 



        <div class="wrapper">
              <swiper swiper ref="mySwiper" class="swiper mySwiper2" v-bind:options="swiperOptions1">
                    <div class="swiper-slide">
                      <img src="../../assets//images/family/img1d.png" />
                    </div>
                    <div class="swiper-slide">
                      <img src="../../assets//images/family/img2d.png" />
                    </div>
                    <div class="swiper-slide">
                      <img src="../../assets//images/family/img3d.png" />
                    </div>
                    <div class="swiper-slide">
                      <img src="../../assets//images/family/img4d.png" />
                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
              </swiper>
        </div>







        <div  thumbsSlider="" class="swiper mySwiper">
              <swiper swiper ref="mySwiper" class="swiper mySwiper2" v-bind:options="swiperOptions2">
                <div class="swiper-slide">
                    <img src="../../assets//images/family/img1x.png" />
                </div>
                <div class="swiper-slide">
                  <img src="../../assets//images/family/img2x.png" />
                </div>
                <div class="swiper-slide">
                  <img src="../../assets//images/family/img3x.png" />
                </div>
                <div class="swiper-slide">
                  <img src="../../assets//images/family/img4x.png" />
                </div>
              </swiper>
        </div> -->
        <div style="width: 1100px; margin: 0 auto; margin-top: 100px">
          <img
            style="display: block; margin: 0 auto; width: 100%"
            src="https://img.duoduiduo.com/gg/4/5/e29bdcd5707743bab806e62acdc99f1b.jpg"
            alt=""
          />
          <!-- <img style="display: block;margin: 0 auto;width: 100%;" src="../../assets/images/family/img123_p5.png" alt="">
        <img style="display: block;margin: 0 auto;width: 100%;" src="../../assets/images/family/img123_p6.png" alt=""> -->
        </div>
      </div>

      <div>
        <img
          style="display: block; width: 100%"
          src="https://img.duoduiduo.com/gg/19/27/9668ba6bb22d46af94fa846426217af8.jpg"
          alt=""
        />
      </div>

      <!-- <div class="line"></div> -->

      <!--      <div class="swytList">-->
      <!--        <ul>-->
      <!--          <li><img src="~img/about/xqs.png" alt=""><br>新趋势</li>-->
      <!--          <li><img src="~img/about/xjs.png" alt=""><br>新技术</li>-->
      <!--          <li><img src="~img/about/xms.png" alt=""><br>新模式</li>-->
      <!--          <li><img src="~img/about/xyt.png" alt=""><br>新业态</li>-->
      <!--        </ul>-->
      <!--      </div>-->
      <!--物联网独角兽-->
      <!-- <div class="wlw swyt">
				<div class="topImg"><img src="~img/about/yitihua.png" alt=""></div>
				<div class="yth">
					<ul class="container">
						<li class="ge">多对多物联网系统</li>
						<li class="ge2">多对多数据中心</li>
						<li class="ge">多对多物联网运行中心</li>
						<li class="tao">多对多物联网生态标准</li>
						<li class="ge">通用及定制功能相结合的智慧生活平台</li>
						<li class="zhang">多场景、多服务、多应用、多产业互联互通的物联网</li>
					</ul>
				</div>
			</div> -->
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import aboutNav from "./aboutNav";
export default {
  name: "synopsis",
  data() {
    return {
      swiperOptionTop: {
        slidesPerView: 1,
        initialSlide: 0,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: true,
        autoplay: {
          delay: 5000, //1秒切换一次
        },
        // direction: "horizontal"
      },
      swiperOptionThumbs: {
        spaceBetween: 20,
        centeredSlides: false,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
      swiperData: [
        {
          imgUrl: require("../../assets/images/family/img1d.png"),
        },
        {
          imgUrl: require("../../assets/images/family/img2d.png"),
        },
        {
          imgUrl: require("../../assets/images/family/img3d.png"),
        },
        {
          imgUrl: require("../../assets/images/family/img4d.png"),
        },
        {
          imgUrl: require("../../assets/images/family/img5d.png"),
        },
      ],
      swiperData1: [
        {
          imgUrl: require("../../assets/images/family/img1x.png"),
        },
        {
          imgUrl: require("../../assets/images/family/img2x.png"),
        },
        {
          imgUrl: require("../../assets/images/family/img3x.png"),
        },
        {
          imgUrl: require("../../assets/images/family/img4x.png"),
        },
        {
          imgUrl: require("../../assets/images/family/img5x.png"),
        },
        {
          imgUrl: require("../../assets/images/family/img6x.png"),
        },
      ],
      type1: 1,
      type2: 1,
      type3: 1,
      type4: 1,
      type5: 1,
      swytBoxBtn: false,
    };
  },
  created() {
    if (this.$route.query.name == "why") {
      this.$nextTick(() => {
        setTimeout(() => {
          var height = document.getElementById("header").clientHeight;
          document.documentElement.scrollTop = height; //不需要加单位
        }, 10);
      });
    }
  },
  mounted() {
    // this.$nextTick(() => {
    // 	const swiperTop = this.$refs.swiperTop.swiper
    // })
  },

  methods: {
    handleScrollx() {
      console.log("滚动高度", window.pageYOffset);
      console.log(
        "距离顶部高度",
        this.$refs.pronbit.getBoundingClientRect().top
      );
    },
  },
  metaInfo: {
    meta: [
      {
        name: "keywords",
        content:
          "多对多物联集团、银发经济、人口老龄化、心脑血管、慢性疾病、血压高、血糖、体脂管理、中医馆、养生馆、健康管理师、科学工作站、公益行动、老年产品目录、健康机构、客户管理、拓客、医保社保、养生保健、远程管理",
      },
      {
        name: "discription",
        content:
          "多对多物联集团是一家深耕于大健康领域多年的健康管理数智服务商，是华为战略合作伙伴，华为健康数据与多对多实现互联互通。多对多健康管理 SaaS 系统和健康管理拓客赢利AI解决方案，为用户建立健康档案，提供健康 AI 管理。业务涵盖医院、养老机构、社区中心、康养中心、养老院、中医馆、养生馆等。针对人口老龄化现状和银发经济趋势，多对多加入了科学健康指导工作站，百城千镇家庭防大病数智服务健康公益行动办公室。开放专业健康管理师进驻，实现合作加盟共赢。",
      },
    ],
  },
  components: {
    aboutNav,
    swiper,
    swiperSlide,
  },
};
</script>

<style scoped lang="less">
/deep/ .container {
  padding: 0 20px !important;
}
.synopsis {
  // box-shadow: 0 10px 10px -3px #ffeeee;
}

.synopsisText {
  padding-bottom: 80px;

  p {
    padding-top: 2%;
    line-height: 25px;
    font-size: 16px;
  }
}

.synopsisTw {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  div {
    padding: 0;
  }

  .left {
    width: 48%;
    // height: 400px;
    @media (max-width: 576px) {
      width: 100%;
    }
    img {
      width: 100%;
      height: 440px;
    }
  }

  .right {
    box-shadow: 0 -10px 40px 0px #ffeeee;
    display: flex;
    align-items: center;
    width: 52%;
    @media (max-width: 576px) {
      width: 100%;
    }
    ul {
      margin: 0;
      box-shadow: 0 10px 20px 0px #ffeeee;
      padding: 1% 4%;
      font-size: 18px;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      li {
        display: flex;
        flex-direction: row;
        align-items: center;
        // margin-bottom: 1%;
        .imgBox {
          width: 12%;
          position: relative;
          text-align: center;
          background-image: url("../../assets/images/about/back.png");
          background-size: 100% 100%;
          width: 80px;
          height: 85px;
          @media (max-width: 576px) {
            width: 21%;
          }

          img {
            width: 100%;
          }

          p {
            font-size: 18px;
            position: absolute;
            text-align: center;
            width: 80px;
            height: 20px;
            color: #ee7b1d;
            @media (max-width: 576px) {
              width: 100%;
            }
          }

          .p1 {
            top: 20px;
            left: 0px;
          }

          .p2 {
            top: 40px;
            left: 0px;
          }
        }
        .imgBox:hover {
          cursor: pointer;
          background-image: url("../../assets/images/about/backactive.png");
          p {
            color: #fff;
          }
        }

        .line {
          width: 9%;
          height: 1px;
          background: #ee7b1d;
          margin: 0 6px;
        }

        .text {
          width: 76%;

          @media (max-width: 576px) {
            font-size: 1rem;
          }
        }

        &.jzg {
          color: #0040c2;
        }
      }
    }
  }
}

.swyt {
  .title {
    text-align: center;
    padding-top: 80px;
    font-size: 28px;
    color: #000;
    font-weight: bold;
    span {
      color: #00cfc8;
    }
  }

  .line {
    height: 2px;
    width: 50px;
    background: #ee7b1d;
    margin: 20px auto;
  }

  .swytBox_img {
    width: 98%;
    margin: 50px auto;
    img {
      width: 100%;
    }
  }

  .swytBox {
    width: 90%;
    background-color: #fef7ef;
    margin: 160px auto 50px;
    position: relative;
    height: 0;
    display: none;
    img {
      width: 78%;
      margin: -160px auto 0;
      background-size: 100% 100%;
      display: none;
      height: 0;
      width: 0;
    }
    meta {
      position: absolute;
      z-index: 2;
      section {
        font-size: 18px;
        color: #333;
        line-height: 44px;
      }
    }
    .div_2018 {
      top: 280px;
      left: 142px;
    }
    .div_2019 {
      top: 710px;
      left: 360px;
    }
    .div_2020 {
      top: 1170px;
      left: 360px;
    }
    .div_2021 {
      top: 1920px;
      left: 382px;
    }
    .div_future {
      top: 2220px;
      left: 382px;
      h5 {
        margin-bottom: 50px;
      }
    }
    @media (min-width: 1700px) and (max-width: 3000px) {
      .div_2018 {
        top: 380px;
        left: 142px;
      }
      .div_2019 {
        top: 900px;
        left: 400px;
      }
      .div_2020 {
        top: 1380px;
        left: 400px;
      }
      .div_2021 {
        top: 1920px;
        left: 382px;
      }
      .div_future {
        top: 2240px;
        left: 432px;
        h5 {
          margin-bottom: 50px;
        }
      }
    }
    @media (min-width: 768px) and (max-width: 1200px) {
      .div_2018 {
        top: 150px;
        left: 142px;
      }
      .div_2019 {
        top: 430px;
        left: 400px;
      }
      .div_2020 {
        top: 780px;
        left: 400px;
        p {
          line-height: 34px;
        }
      }
      .div_2021 {
        top: 1320px;
        left: 382px;
      }
      .div_future {
        top: 2240px;
        left: 432px;
        h5 {
          margin-bottom: 50px;
        }
      }
    }
    @media (max-width: 576px) {
      width: 100%;
      margin: 56px auto 50px;
      height: 1000px;
      img {
        width: 78%;
        margin: -56px auto 0;
        background-size: 100% 100%;
        height: 1000px;
      }
      div {
        position: absolute;
        z-index: 2;
        // border: 1px solid #000;
        p {
          font-size: 12px;
          color: #333;
          line-height: 17px;
          margin-bottom: 0;
        }
      }
      .div_2018 {
        top: 82px;
        left: 8px;
        width: 45%;
      }
      .div_2019 {
        top: 244px;
        left: 90px;
        width: 74%;
      }
      .div_2020 {
        top: 414px;
        left: 90px;
        width: 74%;
      }
      .div_2021 {
        top: 674px;
        left: 100px;
        width: 42%;
      }
      .div_future {
        top: 784px;
        left: 100px;
        width: 42%;
        h5 {
          margin-bottom: 10px;
        }
      }
    }
  }
}

.wlw {
  margin-top: 100px;
  box-shadow: 0 -10px 40px 0px #efefef;

  .topImg {
    display: none;

    @media (max-width: 768px) {
      display: block;

      img {
        width: 15%;
        margin-top: 40px;
      }
    }

    @media (max-width: 768px) {
      img {
        width: 18%;
        margin-top: 30px;
      }
    }

    @media (max-width: 446px) {
      img {
        width: 22%;
        margin-top: 20px;
      }
    }

    text-align: center;
  }

  .yth {
    padding: 2% 0;

    @media (max-width: 768px) {
      padding: 0;
    }

    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 14% 5% 5%;
      margin-top: 50px;
      background: url("~img/about/yth.png") no-repeat center;
      background-size: contain;

      @media (max-width: 1200px) {
        padding: 14% 5% 5%;
      }

      @media (max-width: 992px) {
        padding: 14% 5% 5%;
      }

      @media (max-width: 768px) {
        background: none;
        padding: 1% 5% 5%;
        margin-top: 40px;
      }

      @media (max-width: 576px) {
        margin-top: 10px;
      }

      li {
        width: 30%;
        height: 175px;
        padding: 8% 2% 2%;
        line-height: 24px;
        color: #ee7b1d;
        font-size: 18px;
        display: flex;
        align-items: center;

        @media (max-width: 992px) {
          padding: 8% 2% 2%;
          height: 130px;
          font-size: 0.8rem;
          margin-bottom: 0;
        }

        @media (max-width: 768px) {
          height: 120px;
          margin-bottom: 30px;
          width: 45%;
          font-size: 0.9rem;
          padding: 10% 4% 2% 2%;
        }

        @media (max-width: 576px) {
          height: 120px;
          margin-bottom: 20px;
          width: 48%;
          font-size: 0.8rem;
          padding: 10% 4% 2%;
        }

        @media (max-width: 446px) {
          height: 140px;
          width: 80%;
          margin: 20px auto;
          font-size: 0.8rem;
          padding: 18% 12% 4%;
        }

        &.ge {
          background: url("~img/about/ge.png") no-repeat center;
          background-size: contain;
        }

        &.ge2 {
          background: url("~img/about/ge.png") no-repeat center;
          background-size: contain;
        }

        &.tao {
          background: url("~img/about/tao.png") no-repeat center;
          background-size: contain;
          color: #0040c2;
        }

        &.zhang {
          background: url("~img/about/zhang.png") no-repeat center;
          background-size: contain;
          color: #0040c2;
        }
      }
    }
  }
}
.badada {
  display: flex;
  width: 1100px;
  margin: 0 auto;
  justify-content: space-between;
  margin-top: 50px;
  margin-bottom: 50px;
  img {
    display: block;
    margin: 0 auto;
  }
  span {
    font-size: 16px;
    font-weight: 600;
    color: #000;
    display: block;
    text-align: center;
    margin-top: 10px;
  }
  p {
    text-align: center;
    margin-top: 10px;
    color: #999;
  }
  div {
    padding-top: 30px;
    padding-bottom: 30px;
    width: 20%;
    cursor: pointer;
  }
  div:hover {
    border-radius: 10px;
    // background: red;
    box-shadow: 1px 1px 20px rgb(255, 182, 122);
  }
}

.swiper-box .swiper-container {
  border-radius: 30px;
  box-shadow: 10px 10px 22px -10px rgba(0, 0, 0, 0.5);
}

.asdadadada {
  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }

  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  body {
    background: #000;
    color: #000;
  }

  .swiper {
    width: 100%;
    height: 300px;
    margin-left: auto;
    margin-right: auto;
  }

  .swiper-slide {
    background-size: cover;
    background-position: center;
  }

  .mySwiper2 {
    height: 80%;
    width: 100%;
  }

  .mySwiper {
    height: 20%;
    box-sizing: border-box;
    padding: 10px 0;
  }

  .mySwiper .swiper-slide {
    width: 25%;
    height: 100%;

    border-radius: 50%;
  }

  .mySwiper .swiper-slide-thumb-active {
    opacity: 1;
  }

  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .swiper-button-next.swiper-button-white,
  .swiper-container-rtl .swiper-button-prev.swiper-button-white {
    background-image: url("../../assets/images/family/qiehuan.png");
    background-size: 250%;
    right: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about/synopsis.vue